export const PREFIX_URL = '/auth';
export const generateURL = (url: string) => `${PREFIX_URL}${url}`;